/* nono-pdp.js – 10 Oct 2026 site optimisations (01 trust + 03 PDP). Vanilla, no deps.
   1) Size guide bottom sheet ([data-np-sheet-open] -> #SizeGuide-<section>), focus kept inside, Esc / dim / X close.
   2) Mobile gallery: "1 / 5" counter + dots that follow the swipe.
   3) "Add to basket · £12.99": keeps the live price of the selected size on the button after a variant change. */
(() => {
  const money = (c) => { const f = (window.nonoTheme && window.nonoTheme.moneyFormat) || '£{{amount}}'; const n = (c / 100).toFixed(2); return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => (k === 'amount_no_decimals' ? String(Math.round(c / 100)) : k === 'amount_with_comma_separator' ? n.replace('.', ',') : n.replace(/\B(?=(\d{3})+(?!\d))/g, ','))); }; // QA 2026-10-11 (S6)

  /* ---------- 1. size guide sheet ---------- */
  let lastFocus = null;
  const focusables = (el) => [...el.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((x) => x.offsetParent !== null);
  /* P2 2026-10-13 (WebKit axe target-size on .header__icon--search behind the size guide): make the page behind the open sheet inert,
     so it can't be tapped or reached and drops out of the a11y tree. Only touches elements we set; restores them on close. */
  let inerted = [];
  const inertBg = (sheet) => {
    inerted.forEach((el) => el.removeAttribute('inert')); inerted = [];
    if (!sheet) return;
    [...document.body.children].forEach((el) => { if (el !== sheet && !el.hasAttribute('inert') && !/^(SCRIPT|STYLE|LINK)$/.test(el.tagName)) { el.setAttribute('inert', ''); inerted.push(el); } });
  };
  const closeSheet = (sheet) => {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('np-lock');
    inertBg(null);
    setTimeout(() => { sheet.hidden = true; }, 220);
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  };
  const openSheet = (sheet, opener) => {
    if (!sheet) return;
    lastFocus = opener || document.activeElement;
    if (sheet.parentElement !== document.body) document.body.appendChild(sheet); // escape transformed / sticky parents
    sheet.hidden = false;
    document.documentElement.classList.add('np-lock');
    inertBg(sheet);
    requestAnimationFrame(() => {
      sheet.classList.add('is-open');
      const x = sheet.querySelector('.np-sheet__x');
      (x || sheet.querySelector('.np-sheet__panel')).focus();
    });
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-np-sheet-open]');
    if (o) { e.preventDefault(); openSheet(document.getElementById(o.dataset.npSheetOpen), o); return; }
    const c = e.target.closest('[data-np-sheet-close]');
    if (c) { e.preventDefault(); closeSheet(c.closest('.np-sheet')); }
  });
  document.addEventListener('keydown', (e) => {
    const sheet = document.querySelector('.np-sheet.is-open');
    if (!sheet) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(sheet); return; }
    if (e.key === 'Tab') {
      const f = focusables(sheet); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- 2. mobile gallery counter + dots ---------- */
  const initGallery = () => {
    document.querySelectorAll('media-gallery').forEach((g) => {
      if (g.dataset.npDots) return;
      const list = g.querySelector('.product__media-list');
      if (!list) return;
      const slides = [...list.querySelectorAll('.product__media-item')];
      if (slides.length < 2) return;
      g.dataset.npDots = '1';
      const viewer = list.closest('slider-component') || list.parentElement;
      const cnt = document.createElement('span');
      cnt.className = 'np-gcount'; cnt.setAttribute('aria-hidden', 'true');
      const dots = document.createElement('div');
      dots.className = 'np-gdots'; dots.setAttribute('aria-hidden', 'true');
      dots.innerHTML = slides.map(() => '<i></i>').join('');
      viewer.style.position = 'relative';
      viewer.appendChild(cnt);
      viewer.insertAdjacentElement('afterend', dots);
      const set = () => {
        const w = slides[0].getBoundingClientRect().width || 1;
        const gap = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : w;
        const i = Math.max(0, Math.min(slides.length - 1, Math.round(list.scrollLeft / (gap || w))));
        cnt.textContent = (i + 1) + ' / ' + slides.length;
        [...dots.children].forEach((d, j) => d.classList.toggle('on', j === i));
      };
      let t = null;
      list.addEventListener('scroll', () => { if (t) return; t = requestAnimationFrame(() => { t = null; set(); }); }, { passive: true });
      set();
    });
  };

  /* ---------- 3. Add to basket · price ---------- */
  const setButton = (sectionId, v) => {
    const btn = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!btn || !v) return;
    const label = btn.querySelector('span');
    if (!label || btn.disabled || !v.available || btn.dataset.npPrice !== 'true') return;
    const p = v.price; // 2026-10-13: real price only; sale shown via compare-at
    const base = (window.variantStrings && window.variantStrings.addToCart) || 'Add to basket';
    label.textContent = base + ' · ' + money(p);
  };
  const boot = () => {
    initGallery();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
        const d = ev && ev.data; if (!d) return;
        setButton(d.sectionId, d.variant);
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
